export const PromotionalProducts = {
    SurveyScramble: {
        slug: 'the-jackbox-survey-scramble',
        productId: 'gid://shopify/Product/7266062794886',
        variantId: 'gid://shopify/ProductVariant/41351595163782'
    },
    PartyPack1: {
        slug: 'the-jackbox-party-pack-1',
        productId: 'gid://shopify/Product/2549160050768',
        variantId: 'gid://shopify/ProductVariant/21891922034768'
    },
    PartyPack2: {
        slug: 'the-jackbox-party-pack-2',
        productId: 'gid://shopify/Product/2549145436240',
        variantId: 'gid://shopify/ProductVariant/21891888742480'
    },
    PartyPack3: {
        slug: 'the-jackbox-party-pack-3',
        productId: 'gid://shopify/Product/2549131673680',
        variantId: 'gid://shopify/ProductVariant/21891846144080'
    },
    PartyPack4: {
        slug: 'the-jackbox-party-pack-4',
        productId: 'gid://shopify/Product/2548058685520',
        variantId: 'gid://shopify/ProductVariant/21888543195216'
    },
    PartyPack5: {
        slug: 'the-jackbox-party-pack-5',
        productId: 'gid://shopify/Product/1428090912848',
        variantId: 'gid://shopify/ProductVariant/12551944536144'
    },
    PartyPack6: {
        slug: 'the-jackbox-party-pack-6',
        productId: 'gid://shopify/Product/3754672193616',
        variantId: 'gid://shopify/ProductVariant/29247379570768'
    },
    PartyPack7: {
        slug: 'the-jackbox-party-pack-7',
        productId: 'gid://shopify/Product/5154839560326',
        variantId: 'gid://shopify/ProductVariant/40192364576902'
    },
    PartyPack8: {
        slug: 'the-jackbox-party-pack-8',
        productId: 'gid://shopify/Product/6613464514694',
        variantId: 'gid://shopify/ProductVariant/39492429873286'
    },
    PartyPack9: {
        slug: 'the-jackbox-party-pack-9',
        productId: 'gid://shopify/Product/6758454657158',
        variantId: 'gid://shopify/ProductVariant/39850036789382'
    },
    PartyPack10: {
        slug: 'the-jackbox-party-pack-10',
        productId: 'gid://shopify/Product/6897951572102',
        variantId: 'gid://shopify/ProductVariant/40229789630598'
    },
    PartyPack11: {
        slug: 'the-jackbox-party-pack-11',
        productId: 'gid://shopify/Product/7424678232198',
        variantId: 'gid://shopify/ProductVariant/42183813333126'
    },
    PartyPack12: {
        slug: 'the-jackbox-party-pack-12',
        productId: 'gid://shopify/Product/7733186396294',
        variantId: 'gid://shopify/ProductVariant/44368606789766'
    },
    QuintPack1: {
        slug: 'the-jackbox-party-quintpack',
        productId: 'gid://shopify/Product/4506172686470',
        variantId: 'gid://shopify/ProductVariant/31764039303302'
    },
    QuintPack2: {
        slug: 'the-jackbox-party-quintpack-2',
        productId: 'gid://shopify/Product/6997346517126',
        variantId: 'gid://shopify/ProductVariant/40538528579718'
    },
    BigBangBundle: {
        slug: 'the-jackbox-big-bang-bundle',
        productId: 'gid://shopify/Product/7449352601734',
        variantId: 'gid://shopify/ProductVariant/42391415619718'
    },
    BackpackBundle: {
        slug: 'the-jackbox-backpack-bundle',
        productId: 'gid://shopify/Product/7733184462982',
        variantId: 'gid://shopify/ProductVariant/44368601612422'
    },
    TMP3: {
        slug: 'trivia-murder-party-3',
        productId: 'gid://shopify/Product/7733183381638',
        variantId: 'gid://shopify/ProductVariant/44368599580806'
    },
    FakinItXL: {
        slug: 'fakin-it-xl',
        productId: 'gid://shopify/Product/7738214383750',
        variantId: 'gid://shopify/ProductVariant/44388922097798'
    }
}

export function getPartyPack(packNum: number): string {
    const key = `PartyPack${packNum}` as keyof typeof PromotionalProducts
    const variantId = PromotionalProducts[key]?.variantId
    if (!variantId) {
        throw new Error(`Party Pack ${packNum} not found.`)
    }
    return variantId
}
